<template>
  <section>
    <a id="thetop" name="thetop" />
    <div class="container contactUs" style="padding:3%;">
      <div
        class="head-container"
      >
        <span class="a2 bluefont text-left">
          Questions About Small Business Loans from American Credit
          <sup>®</sup>
? Contact
          Us Now
        </span>
        <div class="a4 text-left" style="font-weight:700;">
          Get the credit you deserve from a lender
          <br />you can trust.
        </div>
        <br />
        <br />

        <button
          @click="this.window.location.href='/login'"
          class="btn text-white rounded-pill"
          style="background:rgb(3, 28, 212);"
        >
          <p class="head-button-text button-text">Apply Now</p>
        </button>
      </div>
    </div>



    <div class="container bluebg pt-3 pb-2">
      <div class="contexbox">
        <h2 class="text-white font-weight-bold">Sitemap</h2>
        <ul class="sitemap-list">
            <li>
                <a href="/">Home</a>
            </li>
            <li>
                <a href="/equipment-loan">Asset-Based Loans</a>
            </li>
            <li>
                <a href="/invoice-factoring">AR/Invoice Factoring</a>
            </li>
            <li>
                <a href="/loan-calculator">Loan Calculator</a>
            </li>
            <li>
                <a href="/roi-calculator">ROI Calculator</a>
            </li>
            <li>
                <a href="/faq">FAQs</a>
            </li>
            <li>
                <a href="/blog">Blog</a>
            </li>
            <li>
                <a href="/partners">Partners</a>
            </li>
            <li>
                <a href="/careers">Careers</a>
            </li>
            <li>
                <a href="/about-us">About Us</a>
            </li>
            <li>
                <a href="/team">Team</a>
            </li>
            <li>
                <a href="/why-american-credit">Why American Credit</a>
            </li>
            <li>
                <a href="/invest">Investor</a>
            </li>
            <li>
                <a href="/contact-us">Contact Us</a>
            </li>
        </ul>
      </div>
    </div>

    <div class="container text-center whitebg">
      <div class="contexbox text-center">
        <br />
        <br />
        <div>
          <img
            src="../assets/imgs/istockphoto-497981184-2048x2048.png"
            class="img-responsive center-block"
            alt="customer"
          />
        </div>
        <h5>
          <p class="triangle-border middle">
            <span class="font-weight-bold">
              <i>"A growing family business keeps you running 24/7. I can’t spend days applying and months waiting for a loan. We need to keep things moving."</i>
            </span>
            <br />
          </p>
        </h5>
        <br />
        <h5>With American Credit time is on your side. When the clock is ticking, our streamlined approval process takes just minutes once your application is complete.</h5>
        <a href="/why-american-credit">
          <h5 class="font-weight-bold">
            <span style="text-decoration: underline;">See how easy we make it.</span>
          </h5>
        </a>
        <br />
        <button
          @click="this.window.location.href='/get-start'"
          class="btn btn-info rounded-pill px-4 py-2"
          style="background:rgb(3, 28, 212);"
        >
          <p class="button-text">APPLY NOW</p>
        </button>
        <br />
        <br />
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import * as types from "../vuex/types";
import _ from "lodash";
import api from "../vuex/api/index";

export default {
  data() {
    return {
      rules: {},
      isLoading: false,

      step2Form: {
        firstName: "",
        middleName: "",
        lastName: "",
        email: "",
        phone: "",
        content: "",
        streetAddress: "",
        streetAddress2: "",
        cityName: "",
        title: "",
        city: "",
        personDocumentType: "",
        zipCode: "",
        state: "",
        ssn: "",
        dateOfBirth: "",
        dateOfBirth2: "",
        homeOwnership: "",
        military: false,
        month: "",
        housingCost: ""
      }
    };
  },
  computed: {
    ...mapGetters({
      userInfo: types.GET_USER
    })
  },
  methods: {
    submitForm() {
      this.isLoading = true;
      var _this = this;
      api
        .postForm("/common/sysfeedback/mgxyContact.ht", {
          tokenId: _this.userInfo.token,
          lastName: _this.step2Form.lastName,
          firstName: _this.step2Form.firstName,
          email: _this.step2Form.email,
          phone: _this.step2Form.phone,
          content: _this.step2Form.content
        })
        .then(res => {
          this.isLoading = false;
          this.$router.push({
            path: `/`,
            query: {}
          });
        });
    }
  }, //end of methods
  mounted() {
    var seo = document.getElementById("seo")

    var meta=document.getElementById("seometa");
    if(!meta){
    meta=document.createElement("meta");
    meta.name="description";
    meta.id="seometa";
    document.head.insertBefore(meta,seo);
    }
    
    var keywords=document.getElementById("seokeywords");
    if(!keywords){
    keywords=document.createElement("meta");
    keywords.name="keywords";
    keywords.id="seokeywords"
    document.head.insertBefore(keywords,seo);
    }

    document.title = "Contact American Credit | Call, Chat or Form Fill";
    meta.content =
      "Have questions about American Credit's small business loans? Give us a call, chat online or use our secure form. Our loan specialists are here to help you!";
    keywords.content = "american credit background, small business financing, american credit history, american credit";
  }
};
</script>

<style lang="scss">
.el-input.is-disabled .el-input__inner {
  background: #f7f7f7;
}

.step1-form .step-form__title {
  padding-bottom: 120px;
}

.second_main {
  margin-top: 10px;
  width: 61.8%;
  align: center;
  margin-left: 300px;
  margin-right: 300px;
}

.second_title {
  padding: 3px 0px 15px 0px;
  color: #747474;
}

.second_main .el-form-item__label {
  text-align: center;
}

.second_main input {
  margin-left: 0;
}

.second_main .label_text .el-form-item__label {
  width: 14% !important;
}

.second_main .label_text .el-form-item__content {
  margin-left: 15% !important;
}

.select_width .el-input__icon + .el-input__inner {
  padding-right: 95px;
}

.Infosave {
  margin: 15px 0px;
}

.sitemap-list {
    // display: list-item;
    // list-style: circle;
    li {
        list-style: disc outside none;
        display: list-item;
        margin-left: 20px;
        a {
            color: white;
        }
    }
}
</style>



// WEBPACK FOOTER //
// sitemap.vue?897e6c84